module.exports = __webpack_public_path__ + "eu.svg?824e473c761930ef1f65fe53a04a4f18";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/eu.svg
// module id = 1456
// module chunks = 0